import { render, staticRenderFns } from "./CategorySelect.vue?vue&type=template&id=8dcbb422&scoped=true"
import script from "./CategorySelect.vue?vue&type=script&lang=js"
export * from "./CategorySelect.vue?vue&type=script&lang=js"
import style0 from "./CategorySelect.vue?vue&type=style&index=0&id=8dcbb422&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcbb422",
  null
  
)

export default component.exports